import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { compose } from "recompose";
import { SnackbarProvider } from "notistack";
import DismissSnackbar from "./DismissSnackbar";

const styles = theme => ({
  success: { backgroundColor: theme.infoBGColor, color: theme.infoTextColor },
  error: { backgroundColor: theme.errorBGColor, color: theme.errorTextColor },
  warning: { backgroundColor: theme.warningBGColor, color: theme.warningTextColor },
  info: { backgroundColor: theme.infoBGColor, color: theme.infoTextColor }
});

class StyledSnackbar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    return (
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        action={key => <DismissSnackbar snackBarId={key} />}
        autoHideDuration={2000}
        classes={{
          variantSuccess: classes.success,
          variantError: classes.error,
          variantWarning: classes.warning,
          variantInfo: classes.info
        }}
      >
        {this.props.children}
      </SnackbarProvider>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme()
)(StyledSnackbar);
